import { ComponentStyleConfig } from '@chakra-ui/theme';

const divider: ComponentStyleConfig = {
  baseStyle: {
    borderColor: 'rgba(0, 0, 0, 0.10)',
    borderWidth: '1px',
    mb: '20px'
  },
  variants: {
    spacing: {
      my: '60px',
      borderStyle: 'solid'
    }
  }
};

export default divider;
